import React from 'react';
import Icon from 'react-icons/lib/md/info';

import {
    CardBlock
} from 'reactstrap';
const PageEmptyContent = ({message}) => (
    <div>
        <CardBlock className="table-responsive">
            <div className="row">
                <div className="col-md-12">
                    <div className="text-center">
                        <Icon size="70" color="#43a8df"/>
                    </div>
                    <h5 className="text-center mt-2">
                        {message}
                    </h5>
                </div>
            </div>
        </CardBlock>
    </div>
);
export default PageEmptyContent;



// WEBPACK FOOTER //
// ./src/views/utils/page.empty-content.js